import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from '@/lib/queryKeys'

import { getPaymentSummary } from '../paymentsService'
import { PaymentSummaryPayload } from '../types/PaymentSummaryPayload'
import { PaymentSummaryResponse } from '../types/PaymentSummaryResponse'

export const usePaymentSummary = ({ pkgId, isInsuranceAdded, couponCode, creditToUseUSD }: PaymentSummaryPayload) => {
  return useQuery<PaymentSummaryResponse>({
    queryKey: [QUERY_KEYS.PACKAGE_PAYMENTS_SUMMARY, pkgId, isInsuranceAdded, couponCode ?? '', creditToUseUSD ?? 0],
    queryFn: () =>
      getPaymentSummary({
        pkgId: pkgId!,
        isInsuranceAdded,
        couponCode,
        creditToUseUSD,
      }),
    enabled: !!pkgId,
    keepPreviousData: true,
    refetchOnMount: true,
  })
}
